import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import moment from 'moment/moment';
import ProfessionSpecialty from '../../../components/ProfessionSpecialty/index';
import { TitleYearsInput } from '../../../components/TitleYears';
import { WorkExperienceInput } from '../../../components/WorkExperience';
import Achievements from '../../../components/Achievements/index';
import VideoList from '../../../components/VideoList/index';
import Interests from '../../../utils/Interests';
import ValidatesFormWith from '../../../utils/ValidatesFormWith';
import validationSchema from './artistValidation';
import Input from '../../../components/Input';
import Countries from '../../../utils/Countries';
import Select from '../../../components/Select';
import Birthday from '../../../components/Birthday';
import Textarea from '../../../components/Textarea';
import UploadFilesField from '../../../components/UploadFilesField';
import UploadImageField from '../../../components/UploadImageField';
import Checkbox from '../../../components/Checkbox';
import CleanTitleYears from '../../../transforms/CleanTitleYears';
import CleanUploadFile from '../../../transforms/CleanUploadFile';
import CleanWorkExperience from '../../../transforms/CleanWorkExperience';
import CleanAchievements from '../../../transforms/CleanAchievements';

class ArtistForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      formError: '',
    };
  }
  onChangeInterest = (e, props) => {
    const { name, checked } = e.target;
    let { interests } = props.values;

    if (!interests) {
      interests = [];
    }

    interests = (interests.slice() || []);

    const index = interests.indexOf(name);

    if (checked && index === -1) {
      interests.push(name);
    } else if (index > -1) {
      interests.splice(index, 1);
    }

    props.setFieldValue('interests', interests);
    props.setFieldTouched('interests', true);
  };

  process = (values) => {
    const user = {
      agency: values.agency,
      agencyEmail: values.agencyEmail,
      agencyWeb: values.agencyWeb,
      name: values.name,
      lastname: values.lastname,
      website: values.website,
      biography: values.biography,
      profession: values.profession,
      facebook: values.facebook,
      twitter: values.twitter,
      linkedin: values.linkedin,
      youtube: values.youtube,
      soundcloud: values.soundcloud,
      specialty: values.specialty,
      birthday: values.birthday.format('YYYY-MM-DD'),
      nationality: values.nationality,
      residence: values.residence,
      images: values.images.map(image => ({
        url: image.url,
      })),
      cv: (values.cv && values.cv.length > 0) ? CleanUploadFile(values.cv[0]) : {},
      formal_education: values.formal_education.map(e => CleanTitleYears(e)),
      informal_education: values.informal_education.map(e => CleanTitleYears(e)),
      support: values.support.map(e => CleanTitleYears(e)),
      work_experience: values.work_experience.map(e => CleanWorkExperience(e)),
      achievements: values.achievements.map(a => CleanAchievements(a)),
      clips: values.clips.map(image => ({
        url: image.url,
      })),
      videos: values.videos.map(video => ({
        url: video.url,
      })),
      interests: values.interests,
      showAge: values.showAge,
    };
    this.props.onEditUser(user);
  };

  render() {
    const {
      user,
      success,
    } = this.props;
    const {
      formError,
    } = this.state;
    let cv = [];
    if (user.cv && user.cv.name !== null && user.cv.url !== null) {
      cv = [user.cv];
    }
    console.log(user);
    return (
      <Formik
        enableReinitialize
        initialValues={{
          agency: user.agency || '',
          agencyEmail: user.agencyEmail || '',
          agencyWeb: user.agencyWeb || '',
          name: user.name || '',
          lastname: user.lastname || '',
          website: user.website || '',
          biography: user.biography || '',
          profession: user.profession || '',
          specialty: user.specialty || '',
          facebook: user.facebook || '',
          twitter: user.twitter || '',
          linkedin: user.linkedin || '',
          youtube: user.youtube || '',
          soundcloud: user.soundcloud || '',
          birthday: (user.birthday && moment(user.birthday)) || undefined,
          nationality: user.nationality || '',
          residence: user.residence || '',
          images: user.images || [],
          cv,
          formal_education: user.formal_education || [],
          informal_education: user.informal_education || [],
          support: user.support || [],
          work_experience: user.work_experience || [],
          achievements: user.achievements || [],
          clips: user.clips || [],
          videos: user.videos || [],
          interests: user.interests || [],
          showAge: user.showAge || false,
        }}
        onSubmit={this.process}
        validate={(u) => {
          const validationOutput = ValidatesFormWith(validationSchema)(u);
          console.log(validationOutput);
          const valid = Object.keys(validationOutput).length === 0;
          if (valid) {
            this.setState({
              formError: '',
            });
          } else {
            this.setState({
              formError: 'El formulario contiene errores',
            });
          }
          return validationOutput;
         }}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="search-contents-sidebar">
              <div className="row">
                <div className="col-md-12">
                  {success === false && (
                    <div className="alert alert-danger" role="alert">
                      Ocurrió un problema al intentar modificar tu información
                    </div>
                  )}
                  {success === true && (
                    <div className="alert alert-success" role="alert">
                      Información actualizada correctamente
                    </div>
                  )}
                </div>
                <div className="col-md-6">
                  <Input
                    label="Nombre"
                    name="name"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Apellido"
                    name="lastname"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-4">
                  <Select
                    label="Nacionalidad"
                    name="nationality"
                    placeholder="Seleccione su nacionalidad"
                    options={Countries}
                  />
                </div>
                <div className="col-md-4">
                  <Select
                    label="País de residencia"
                    name="residence"
                    placeholder="Seleccione país de residencia"
                    options={Countries}
                  />
                </div>
                <div className="col-md-4">
                  <Birthday
                    label="Fecha de nacimiento"
                    name="birthday"
                  />

                </div>
              </div>
              <div className="row">
                <ProfessionSpecialty />
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Facebook"
                    name="facebook"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Twitter"
                    name="twitter"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Linkedin"
                    name="linkedin"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Youtube"
                    name="youtube"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Sitio Web"
                    name="website"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Audio de Soundcloud"
                    name="soundcloud"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    label="Biografía"
                    name="biography"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <UploadFilesField
                    pdf
                    doc
                    name="cv"
                    label="Curriculum Vitae"
                    title="Curriculum Vitae"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <UploadImageField
                    label="Imágenes"
                    name="images"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <h2 className="heading">Agencia / Manager</h2>

                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        label="Agencia"
                        name="agency"
                      />
                    </div>
                    <div className="col-md-6">
                      <Input
                        type="email"
                        label="Correo electrónico"
                        name="agencyEmail"
                      />
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <Input
                        label="Sitio Web"
                        name="agencyWeb"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <TitleYearsInput
                    list={props.values.formal_education}
                    touched={!!props.touched.formal_education}
                    error={props.errors.formal_education}
                    onTouched={() => { props.setFieldTouched('formal_education', true); }}
                    onChange={(exp) => { props.setFieldValue('formal_education', exp); }}
                    title="Estudios formales"
                    notAdded="Aún no has añadido estudios formales"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <TitleYearsInput
                    list={props.values.informal_education}
                    touched={!!props.touched.informal_education}
                    error={props.errors.informal_education}
                    onTouched={() => { props.setFieldTouched('informal_education', true); }}
                    onChange={(exp) => { props.setFieldValue('informal_education', exp); }}
                    title="Estudios informales"
                    notAdded="Aún no has añadido estudios informales"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <TitleYearsInput
                    list={props.values.support}
                    touched={!!props.touched.support}
                    error={props.errors.support}
                    onTouched={() => { props.setFieldTouched('support', true); }}
                    onChange={(exp) => { props.setFieldValue('support', exp); }}
                    title="Becas y ayudas"
                    notAdded="Aún no has añadido becas y ayudas"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <WorkExperienceInput
                    list={props.values.work_experience}
                    touched={!!props.touched.work_experience}
                    error={props.errors.work_experience}
                    onTouched={() => { props.setFieldTouched('work_experience', true); }}
                    onChange={(exp) => { props.setFieldValue('work_experience', exp); }}
                    title="Experiencia de trabajo"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <Achievements
                    list={props.values.achievements}
                    touched={!!props.touched.achievements}
                    error={props.errors.achievements}
                    onTouched={() => { props.setFieldTouched('achievements', true); }}
                    onChange={(exp) => { props.setFieldValue('achievements', exp); }}
                    title="Reconocimientos"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <UploadImageField
                    label="Recortes de prensa"
                    name="clips"
                  />
                </div>
              </div>
              <div className="row mb-section">
                <div className="col-md-12">
                  <VideoList
                    list={props.values.videos}
                    touched={!!props.touched.videos}
                    error={props.errors.videos}
                    onTouched={() => { props.setFieldTouched('videos', true); }}
                    onChange={(videos) => { props.setFieldValue('videos', videos); }}
                    title="Videos de Youtube"
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <h2 className="heading">Intereses</h2>

                  <div className="row">
                    {Interests.map(i => (
                      <div className="col-md-4" key={i}>
                        <div className="checkbox checkbox-theme checkbox-circle">
                          <input id={i} name={i} defaultChecked={props.values.interests.indexOf(i) !== -1} type="checkbox" onChange={e => this.onChangeInterest(e, props)} />
                          <label htmlFor={i}>
                            {i}
                          </label>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Checkbox
                    label="¿Deseas que tu edad aparezca en tu perfíl?"
                    checkLabel="Si, quisiera que aparezca"
                    name="showAge"
                  />
                </div>
              </div>

              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Guardar</span>
                  <div className="clear" />
                </button>
                {formError && (
                  <div className="input-text-error-msg" role="alert">
                    {formError}
                  </div>
                )}
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

ArtistForm.propTypes = {
  onEditUser: PropTypes.func,
};

ArtistForm.defaultProps = {
  onEditUser: () => {},
};


export default ArtistForm;



// WEBPACK FOOTER //
// ./src/containers/Profile/EditProfile/ArtistForm.js